import { GeocodeResult } from '@googlemaps/google-maps-services-js';

import { apiGet } from '../../framework/client';
import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';

export const getGoogleMapsGeoCoding = async (address: string, language: string): Promise<GeocodeResult[]> => {
    const queryParams = { address, language };
    const response = await apiGet('/api/google-maps/geocode', queryParams);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};

export const getGoogleMapsAutocomplete = async (input: string, language: string): Promise<string[]> => {
    const queryParams = { input, language };
    const response = await apiGet('/api/google-maps/autocomplete', queryParams);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};

export const getGoogleMapsJavascriptApiKey = async (): Promise<{ apiKey: string }> => {
    const response = await apiGet('/api/google-maps/apiKey');
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};
